/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {LocationInstance} from '../location-instance';

export class ParentLocationWrapper {
  instance: LocationInstance;
}
